// Generated by Melange


const Bindings = {};

function getItem(name) {
  let value;
  try {
    value = localStorage.getItem(name);
  }
  catch (exn){
    return;
  }
  if (value === "") {
    return;
  } else {
    return value;
  }
}

function setItem(prim0, prim1) {
  localStorage.setItem(prim0, prim1);
}

function removeItem(prim) {
  localStorage.removeItem(prim);
}

export {
  Bindings,
  getItem,
  setItem,
  removeItem,
}
/* No side effect */
